export const contractSaveParametersGeneration = ({
  contactPreferences = {},
  billingData = {},
  contractData,
  characteristicsData,
  mainAddressData = {},
  contractId,
  contactId,
  addressId,
  action = 'save',
  type,
}) => {
  const options = new URLSearchParams()
  const { electricityMeter = {}, gasMeter = {} } = mainAddressData

  options.append('action', action)
  options.append('type', type || '')
  options.append('id', contractId || '')
  options.append('contact_id', contactId || '')
  options.append('address_id', addressId || '')
  options.append('client_type', contactPreferences.clientType || '')
  options.append('prestation_type', characteristicsData.prestationType || '')
  options.append('energy_type', characteristicsData.energyType || '')
  //to-do-v2: check if it is necessary
  options.append('disclaimer_commitment_pro', characteristicsData.disclaimerCommitmentPro ?? '')
  options.append('offer_id', contractData.offerId ? parseInt(contractData.offerId) : '')
  options.append('organisation_id', contractData.providerId ? parseInt(contractData.providerId) : '')
  options.append('provider_external_id', contractData.providerExternalId || '')
  options.append('payment_mode_alt', billingData.paymentModeAlt || '')
  options.append('invoice_sending_mode', billingData.sendingMode || '')

  if (characteristicsData.energyType === 'dual' || characteristicsData.energyType === 'elec') {
    options.append('meter_id_elec', electricityMeter.pdlNo || '')
  }

  if (characteristicsData.energyType === 'dual' || characteristicsData.energyType === 'gas') {
    options.append('meter_id_gas', gasMeter.pceNo || '')
  }

  options.append('whatsapp_consent', contactPreferences.whatsappConsent ? '1' : '0')
  if (contractData.businessCard !== undefined) {
    options.append('business_card', contractData.businessCard === 1 ? '1' : '0')
  }
  if (contactPreferences.createReviewsInteraction) {
    options.append('create_reviews_interaction', '1')
  }

  return options
}
